import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { observer } from "mobx-react";
import * as React from "react";
import { BackIconButton, MobileHeaderContainer } from "./HeaderViewMobile.styles";
import { HeaderViewModelMobile } from "./HeaderViewModelMobile";
import { FlexColumn } from "./common.styles";
import { useViewModel } from "./useViewModel";
import { LightText, MobileTitle } from "./HXMobilePage.styles";
import { TitleHeaderView } from "./HXMobileTitleHeader";
import ChevronLeft from "@mui/icons-material/ChevronLeft";
import { MobileLogoHeader } from "./MobileLogoHeader";
export const HeaderViewMobile = observer((props) => {
    const model = useViewModel(HeaderViewModelMobile, props.container);
    if (model.showLeftAlignedLogo) {
        return _jsx(MobileLogoHeader, { showBottomBorder: true, onClickLogo: () => model.logoOnClick() });
    }
    const leftIconButtons = [];
    if (model.mobileOnBack) {
        leftIconButtons.push(_jsx(BackIconButton, { onClick: model.mobileOnBack, children: _jsx(ChevronLeft, {}) }, "mobile-header-back-button"));
    }
    return (_jsxs(MobileHeaderContainer, { gap: model.headerGap, paddingBottom: model.headerPaddingBottom, children: [_jsx(TitleHeaderView, { showLogo: true, leftIconButtons: leftIconButtons, padButtonsForCenteringTitle: leftIconButtons.length > 0, padding: "0", logoOnClick: () => model.logoOnClick() }), !props.showLogoOnly && (_jsxs(FlexColumn, { gap: 16, alignItems: "center", children: [_jsx(MobileTitle, { children: model.mobilePageTitle }), model.mobilePageText && _jsx(LightText, { center: true, children: model.mobilePageText })] }))] }));
});
